module.exports = __webpack_public_path__ + "static/media/slider-backgroundc-1024x531.8a219b48.jpg";